import { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";
import { toast } from "sonner";
import { useSettings } from "@/context/SettingsContext";
import { setupPushNotifications, isIosNonStandalone } from "@/services/push";

// Global, event-driven modal. Opened via the "matchup:push-gate" window event
// whenever a blocked action (create/join) requires active notifications.
// Shows the dynamic `text_modal_push` copy and an activation button.
export default function PushGateModal() {
  const { text_modal_push } = useSettings();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("matchup:push-gate", handler);
    return () => window.removeEventListener("matchup:push-gate", handler);
  }, []);

  const activate = async () => {
    if (isIosNonStandalone()) {
      toast.info("Sur iPhone, ajoute MatchUp a l'ecran d'accueil (Partager > Sur l'ecran d'accueil) pour activer les notifications.");
      return;
    }
    setBusy(true);
    const ok = await setupPushNotifications();
    setBusy(false);
    if (ok) {
      toast.success("Notifications activees !");
      setOpen(false);
      window.dispatchEvent(new Event("matchup:push-enabled"));
    } else {
      toast.error("Notifications refusees ou indisponibles sur ce navigateur.");
    }
  };

  if (!open) return null;

  return (
    <div
      data-testid="push-gate-modal"
      onClick={() => setOpen(false)}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.72)", display: "flex",
        alignItems: "center", justifyContent: "center", padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%", maxWidth: 360, background: "#111",
          border: "0.5px solid #333", borderRadius: 18, padding: 24,
          position: "relative",
        }}
      >
        <button
          data-testid="push-gate-close"
          onClick={() => setOpen(false)}
          aria-label="Fermer"
          style={{ position: "absolute", top: 14, right: 14, background: "none", border: "none", color: "#9ca3af", cursor: "pointer" }}
        >
          <X size={18} />
        </button>
        <div style={{
          width: 56, height: 56, borderRadius: 999, margin: "0 auto 14px",
          background: "rgba(34,197,94,0.15)", display: "flex",
          alignItems: "center", justifyContent: "center",
        }}>
          <Bell size={26} color="#22c55e" />
        </div>
        <h3 className="font-heading italic uppercase" style={{ fontSize: 17, fontWeight: 900, color: "#fff", textAlign: "center", marginBottom: 10 }}>
          Notifications requises
        </h3>
        <p style={{ fontSize: 14, color: "#d1d5db", textAlign: "center", lineHeight: 1.5, marginBottom: 20 }}>
          {text_modal_push}
        </p>
        <button
          data-testid="push-gate-activate"
          onClick={activate}
          disabled={busy}
          style={{
            width: "100%", minHeight: 48, borderRadius: 12,
            background: busy ? "#1a1a1a" : "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
            border: "none", color: "#fff", fontSize: 14, fontWeight: 700,
            cursor: busy ? "not-allowed" : "pointer",
          }}
        >
          {busy ? "Activation..." : "Activer les notifications"}
        </button>
        <button
          onClick={() => setOpen(false)}
          style={{ width: "100%", minHeight: 40, marginTop: 8, background: "none", border: "none", color: "#6b7280", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
        >
          Plus tard
        </button>
      </div>
    </div>
  );
}
